// frontend/packages/business-console/src/services/sitePreviewService.js
//
// Reads UAT/PROD URLs for the active business so the Console can surface
// a "Preview" link when there are unpublished draft changes.

import { api } from "@upryzze/services";

export async function getSitePreviewUrls() {
  try {
    const { data } = await api.get(`/v2/site-preview/urls`);
    return {
      uatUrl: data?.uatUrl || null,
      prodUrl: data?.prodUrl || null,
    };
  } catch {
    return { uatUrl: null, prodUrl: null };
  }
}
